import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
//angular material
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { HeaderComponent } from './header/header.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
// import { IvyCarouselModule } from 'angular-responsive-carousel';
import { NzTableModule } from 'ng-zorro-antd/table';
//import { ChartsModule } from 'ng2-charts';
import { AddUserComponent } from './add-user/add-user.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { SecurityService } from '../services/security.service';
import { HttpService } from '../services/http.service';
import { HttpClientModule } from '@angular/common/http';
import { AdminService } from '../services/admin.service';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { MatButtonModule } from '@angular/material/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
//ng2-charts
//angular material
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import { LoadingComponent } from './loading/loading.component';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { MainComponent } from './main/main.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FiltersComponent } from './filters/filters.component';
import { AsesorRegisterComponent } from './asesor-register/asesor-register.component';
import { AddQuestionComponent } from './add-question/add-question.component';
import { QuestionsComponent } from './questions/questions.component';
import { AlertComponent } from './alert/alert.component';
import { AddVideoComponent } from './add-video/add-video.component';
import { AddModuleComponent } from './add-module/add-module.component';
import { AddCourseComponent } from './add-course/add-course.component';
import { AddFolderComponent } from './add-folder/add-folder.component';
import { StatisticsChartComponent } from './statistics-chart/statistics-chart.component';
import { DetailAsesorDashboardComponent } from './detail-asesor-dashboard/detail-asesor-dashboard.component';
import { CommentsComponent } from './comments/comments.component';
import { ChangeStateComponent } from './change-state/change-state.component';
import { AddCommentComponent } from './add-comment/add-comment.component';
import { ProfileUserComponent } from './profile-user/profile-user.component';
import { FormProductComponent } from './form-product/form-product.component';
import { ProductsAvailablesComponent } from './products-availables/products-availables.component';
import { ProductConfirmationComponent } from './product-confirmation/product-confirmation.component';
import { ProductsInterestedComponent } from './products-interested/products-interested.component';
import { AddFileComponent } from './add-file/add-file.component';
import { AddPointAgentComponent } from './add-point-agent/add-point-agent.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { LoaderComponent } from './loader/loader.component';
import { AccordionComponent } from './accordion/accordion.component';
import { TabbedAccordionComponent } from './tabbed-accordion/tabbed-accordion.component';
import { StepHeaderComponent } from './step-header/step-header.component';
import { NgChartsModule } from 'ng2-charts';
import { NzMessageModule } from 'ng-zorro-antd/message';

@NgModule({
  declarations: [
    HeaderComponent,
    AddUserComponent,
    LoadingComponent,
    MainComponent,
    SidebarComponent,
    FiltersComponent,
    AsesorRegisterComponent,
    AddQuestionComponent,
    QuestionsComponent,
    AlertComponent,
    AddVideoComponent,
    AddModuleComponent,
    AddCourseComponent,
    AddFolderComponent,
    StatisticsChartComponent,
    DetailAsesorDashboardComponent,
    CommentsComponent,
    ChangeStateComponent,
    AddCommentComponent,
    ProfileUserComponent,
    FormProductComponent,
    ProductsAvailablesComponent,
    ProductConfirmationComponent,
    ProductsInterestedComponent,
    AddFileComponent,
    AddPointAgentComponent,
    LoaderComponent,
    AccordionComponent,
    TabbedAccordionComponent,
    StepHeaderComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatInputModule,
    NzDrawerModule,
    NzInputModule,
    NzSelectModule,
    NzTabsModule,
    MatTabsModule,
    MatDialogModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    NzCarouselModule,
    // IvyCarouselModule,
    NzTableModule,
    NzRadioModule,
    //ChartsModule,
    NzSliderModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzFormModule,
    NzModalModule,
    NzDropDownModule,
    NzLayoutModule,
    NzProgressModule,
    NzSpaceModule,
    MatButtonModule,
    NzCheckboxModule,
    NzEmptyModule,
    NzIconModule,
    NzSwitchModule,
    NzButtonModule,
    NzPaginationModule,
    NzToolTipModule,
    MatTooltipModule,
    NgChartsModule,
    NzMessageModule,
  ],
  exports: [
    HeaderComponent,
    AddUserComponent,
    LoadingComponent,
    MainComponent,
    SidebarComponent,
    FiltersComponent,
    AsesorRegisterComponent,
    QuestionsComponent,
    StatisticsChartComponent,
    DetailAsesorDashboardComponent,
    ChangeStateComponent,
    FormProductComponent,
    CommentsComponent,
    ProductsAvailablesComponent,
    ProductConfirmationComponent,
    ProductsInterestedComponent,
    AlertComponent,
    AddQuestionComponent,
    AddVideoComponent,
    AddModuleComponent,
    AddCourseComponent,
    AddFolderComponent,
    AddCommentComponent,
    AddFileComponent,
    AddPointAgentComponent,
    LoaderComponent,
    ProfileUserComponent,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    NzDrawerModule,
    NzInputModule,
    NzSelectModule,
    NzTabsModule,
    MatTabsModule,
    MatDialogModule,
    MatTooltipModule,
    NzCarouselModule,
    // IvyCarouselModule,
    NzTableModule,
    NzRadioModule,
    //ChartsModule,
    NzSliderModule,
    NzInputNumberModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    NzDatePickerModule,
    NzFormModule,
    NzModalModule,
    NzDropDownModule,
    NzLayoutModule,
    NzProgressModule,
    NzSpaceModule,
    MatButtonModule,
    NzCheckboxModule,
    NzEmptyModule,
    NzIconModule,
    NzSwitchModule,
    NzButtonModule,
    NzPaginationModule,
    NzToolTipModule,
    AccordionComponent,
    TabbedAccordionComponent,
    StepHeaderComponent,
    NgChartsModule,
    NzMessageModule,
  ],
  providers: [
    DatePipe,
    HttpService,
    SecurityService,
    AdminService
  ]
})
export class SharedModule { }
